import RestClient from './rest-client';

export default class BaseRepository {
  client;

  constructor(servicePath, version = 'v1') {
    if (!servicePath) {
      throw new Error('Service path is required');
    }
    this.client = new RestClient(servicePath, version);
  }
}
